import React from "react";
import { LEVEL_WORDS, ORIENTATIVE } from "../../lib/initialAssessmentAdmin";

/** The group's profile: what the trainer reads before the first session. */
export default function GroupProfile({ profile, texts = [] }) {
  const levels = profile.levels || {};
  return (
    <div className="mt-4 grid gap-3 rounded-xl bg-[#F5F6F6] p-3 text-sm" data-testid="group-assessment-profile">
      <div className="text-xs font-semibold uppercase tracking-widest text-[#6B7280]">
        Profilul grupei · {profile.answered} {profile.answered === 1 ? "răspuns" : "răspunsuri"}
      </div>
      <div className="flex flex-wrap gap-2 text-xs">
        {Object.entries(LEVEL_WORDS).map(([key, word]) => (
          <span key={key} className="rounded-full bg-white px-2.5 py-1 font-semibold text-[#373A45]">
            {word}: <span className="tabular-nums">{levels[key] || 0}</span>
          </span>
        ))}
      </div>
      <p className="text-[11px] text-[#6B7280]">{ORIENTATIVE}</p>
      <div>
        <div className="text-xs font-semibold text-[#373A45]">Cât de siguri se simt (media, 1–5)</div>
        <ul className="mt-1 grid gap-1">
          {(profile.situations || []).map((s) => (
            <li key={s.key} className="flex items-baseline justify-between gap-3">
              <span className={s.weakest ? "font-semibold text-[#B42330]" : "text-[#373A45]"}>{s.label}</span>
              <span className="tabular-nums text-[#373A45]">{String(s.mean).replace(".", ",")}</span>
            </li>
          ))}
        </ul>
      </div>
      <Tally title="Instrumente folosite" items={profile.tools} extra={profile.tools_other} />
      <Tally title="Pentru ce au folosit AI" items={profile.uses} />
      <Tally title="Ce îi îngrijorează" items={profile.worries} extra={profile.worries_other} />
      <Tally title="Ce predau" items={profile.taught} />
      <Tally title="De câți ani predau" items={(profile.years || []).filter((y) => y.count > 0)} />
      {texts.length > 0 && (
        <details className="rounded-lg bg-white p-2">
          <summary className="cursor-pointer text-xs font-semibold text-[#373A45]">Răspunsurile libere ({texts.length})</summary>
          <ul className="mt-2 grid gap-2">
            {texts.map((t, i) => (
              <li key={i} className="border-t border-[#E5E7EB] pt-2 first:border-0 first:pt-0">
                <div className="text-xs font-semibold text-[#373A45]">{t.name}</div>
                {t.time && <p className="whitespace-pre-line text-xs text-[#4B5160]"><span className="text-[#6B7280]">Timp: </span>{t.time}</p>}
                {t.goal && <p className="whitespace-pre-line text-xs text-[#4B5160]"><span className="text-[#6B7280]">Ce vrea să știe: </span>{t.goal}</p>}
              </li>
            ))}
          </ul>
        </details>
      )}
    </div>
  );
}

function Tally({ title, items, extra }) {
  if (!(items || []).length) return null;
  return (
    <div>
      <div className="text-xs font-semibold text-[#373A45]">{title}</div>
      <div className="mt-1 flex flex-wrap gap-1.5 text-xs">
        {items.map((it) => (
          <span key={it.key} className="rounded-full bg-white px-2 py-0.5 text-[#373A45]">
            {it.label} <span className="tabular-nums text-[#6B7280]">{it.count}</span>
          </span>
        ))}
      </div>
      {(extra || []).length > 0 && <div className="mt-1 text-[11px] text-[#6B7280]">Altele: {extra.join("; ")}</div>}
    </div>
  );
}
